export default __webpack_public_path__ + "static/char-s-sp03-zh-Hant-ee39ca3b03f9467948347e7ea12d9ea8.png";